
const config = {
  apiOrigin: 'https://api2.fedfis.com',

  drupalOrigin: 'https://staging-www-fedfis.wasya.co',

  env_name: 'production',

  keycloak_client_id: 'fedfis_app',
  keycloak_logout_redirect_url: 'https://dp.fedfis.com',
  keycloak_realm: 'fedfis_frontend3',
  keycloak_url: 'https://login.fedfis.com',

  skip_keycloak: false,

}

export default config

